import { MapContext } from "helpers/map";
import { CSSProperties, useContext } from "react";
import { useTranslation } from "react-i18next";
import styles from "./zooms.module.scss";
import { Tooltip } from "@mui/material"

interface ZoomsProps {
    map?: any;
    style?: CSSProperties;
}

export default function Zooms({ map: mapFromProps, style }: ZoomsProps) {
    const { map: mapFromContext } = useContext(MapContext);
    const [t] = useTranslation();

    const map = mapFromProps || mapFromContext;

    const handleZoomIn = () => {
        if (map) {
            map.zoomIn();
        }
    }

    const handleZoomOut = () => {
        if (map) {
            map.zoomOut();
        }
    }

    return (<div className={styles.zooms} style={style}>
        <Tooltip title={t("map.zoomIn")}>
            <div
                onClick={handleZoomIn}
                style={{ cursor: "pointer" }}
            >
                <span className={styles.zoomIn}>+</span>
            </div>
        </Tooltip>
        <Tooltip title={t("map.zoomOut")}>
            <div
                onClick={handleZoomOut}
                style={{ cursor: "pointer" }}
            >
                <span className={styles.zoomOut}>-</span>
            </div>
        </Tooltip>

    </div>);
}
